import Control from "../../Control";
import NP, {EventArgs} from "../../NP";
import Delegate from "../../Delegate";
import Switcher from "../Switcher/Switcher";
import "./../../ResourcesCore";

export default class AccordionItem extends Control {
	private _contentNode: HTMLElement;
	private _headerNode: HTMLElement;
	private _textNode: HTMLElement;
	private _MaxHeight: number;
	private _HeaderText: string;
	private _imgNode: HTMLElement;
	public EvHeaderClick: Delegate;
	private _Switcher: object;
	private _switcherCtrl: Switcher;

	constructor(settings: object)
	{
		super(settings);
		this._render();
	}

	_initFields(settings: object)
	{
		this._MaxHeight = null;
		this._HeaderText = "";
		this._Switcher = null;
		this.EvHeaderClick = new Delegate();
		super._initFields(settings);
	}

	_render()
	{
		this._initComponent("<div class='accordion__item '>" +
			 "<div class='app-list-item'>" +
			 "<span class='app-list-item__graphic'></span>" +
			 `<span class='app-list-item__text'>${NP.RM.getString(this._RK)}</span>` +
			 "<div class='accordion__item__body'></div>" +
			 "</div>", true);

		this._contentNode = this._root.querySelector('.accordion__item__body');
		this._headerNode = this._root.querySelector('.app-list-item');
		this._textNode = this._root.querySelector('.app-list-item__text');
		this.addEvent(this._headerNode, "click", () => this.EvHeaderClick.fire(this));

		this._imgNode = this._headerNode.querySelector('.app-list-item__graphic');

		if (this._Switcher)
		{
			this._switcherCtrl = new Switcher(this._Switcher);
			this._switcherCtrl.putToNode(this._headerNode);
			this._switcherCtrl.EvClick.add(this._switcherClick, this);
		}

		if (this._MaxHeight)
			this._contentNode.style.maxHeight = this._MaxHeight + "px";
		this._setContentToNode(this._Content, this._contentNode, "Content", true);

		this.collapse();

		if (this._ParentNode)
			this.putToNode(this._ParentNode);

		if (this._HeaderText)
			this.setHeaderText(this._HeaderText);
	}

	getSwitcher()
	{
		return this._switcherCtrl;
	}

	_switcherClick(s: object, e: EventArgs)
	{
		e.Event.preventDefault();
		e.Event.stopPropagation();
	}

	setContent(value: any)
	{
		this._setContentToNode(value, this._contentNode, "Content", true);
	}

	setRK(value: string)
	{
		if (this._RK != value)
		{
			this._RK = value;
			this._textNode.innerText = NP.RM.getString(this._RK);
		}
	}

	setHeaderText(value: string)
	{
		this._textNode.innerText = value;
	}

	toggle()
	{
		if (this.hasClass('accordion__item--active'))
		{
			this.collapse();
		}
		else
		{
			this.open()
		}
	}

	collapse()
	{
		if (this._contentNode.parentNode)
		{
			this._contentNode.parentNode.removeChild(this._contentNode);
			this.removeClass('accordion__item--active');
			NP.removeCssClass(this._imgNode, NP.FontImages.expand_more);
			NP.addCssClass(this._imgNode, NP.FontImages.chevron_right);
		}
	}

	open(animate: boolean = true)
	{
		if (!this._contentNode.parentNode)
		{
			this._root.appendChild(this._contentNode);
			if (animate)
				setTimeout(() => this.addClass('accordion__item--active'), 10);
			else
			{
				this.addClass('accordion__item--active accordion__item--active--no-animate');
				setTimeout(() => this.removeClass('accordion__item--active--no-animate'), 100);
			}

			NP.removeCssClass(this._imgNode, NP.FontImages.chevron_right);
			NP.addCssClass(this._imgNode, NP.FontImages.expand_more);
		}
	}
}